// ==========================================
// BUYERDASHBOARD.JSX - MAIN DASHBOARD
// Estate Experts - Buyer Dashboard Overview
// Professional with variables.css + animations
// Updated with buyerdashboard- prefix
// ==========================================

import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaHome,
  FaCalendarAlt,
  FaBell,
  FaHeart,
  FaBed,
  FaBath,
  FaRuler,
  FaChevronRight,
  FaMapMarkerAlt,
  FaUser,
  FaTree,
  FaBook,
} from "react-icons/fa";
import "../../../assets/css/Buyer/dashboard/buyerdashboard/buyerdashboard.css";
import BuyerMasterLayout from "../../../layouts/BuyerMasterLayout";
import { Container } from "react-bootstrap";
import axios from "axios";
import AppContext from "context/AppContext";

const BuyerDashboard = () => {
  const Navigate = useNavigate();
  const { baseUrl, authToken, baseUrlForFiles } = useContext(AppContext);
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================

  const [wishlist, setWishlist] = useState([1, 2]);
  const [properties, setProperties] = useState();
  const [chats, setChats] = useState([]);
  const [visits, setVisits] = useState([]);
  const [dashboard, setDashboard] = useState("");
  const [savedProp, setSavedProp] = useState("");
  const [visitRequests, setVisitRequests] = useState("");
  const [notifications, setNotifications] = useState("");
  const [wishlistmatches, setWishlistMatches] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // ==========================================
  // STATS DATA
  // ==========================================

  const getDashboardStats = () => {
    console.log("dashboard stats called");
    return axios
      .get(`${baseUrl}/buyer/dashboard/stats`, {
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        setDashboard(response.data.dashboard);
        setSavedProp(response.data.savedProperties);
        setVisitRequests(response.data.visitRequests);
        setNotifications(response.data.notifications);
        setWishlistMatches(response.data.wishlistMatches);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getProperties = () => {
   axios
      .get(`${baseUrl}/buyer/dashboard/savedProperties`, {
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        setProperties(response.data.wishlist);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getChats = () => {
    axios
      .get(`${baseUrl}/buyer/dashboard/latestChats`, {
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        setChats(response.data.chats);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getVisitRequests = () => {
    axios
      .get(`${baseUrl}/buyer/dashboard/nextVisitRequests`, {
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        setVisits(response.data.visits);
        console.log(response.data.visits);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    console.log("=========");
    getDashboardStats();
    getProperties();
    getChats();
    getVisitRequests();
  }, []);
  const statsCards = [
    {
      id: 1,
      icon: <FaHome />,
      title: "Saved Properties",
      value: savedProp,
      color: "#14b8a6",
    },
    {
      id: 2,
      icon: <FaCalendarAlt />,
      title: "Visit Requests",
      value: visitRequests,
      color: "#3b82f6",
    },
    {
      id: 3,
      icon: <FaBell />,
      title: "Notifications",
      value: notifications,
      color: "#f59e0b",
    },
    {
      id: 4,
      icon: <FaHeart />,
      title: "Wishlist Matches",
      value: wishlistmatches,
      color: "#ef4444",
    },
  ];



  // ==========================================
  // AI RECOMMENDATION DATA
  // ==========================================

  const aiRecommendation = {
    plotSize: "300 sq. yd",
    familyMembers: 5,
    housePreference: "4T, BI K",
    output: [
      { icon: <FaHome />, text: "4 BHK + Study" },
      { icon: <FaMapMarkerAlt />, text: "Spacious Living Area" },
      { icon: <FaTree />, text: "Backyard Garden" },
    ],
  };

  // ==========================================
  // FUNCTIONS
  // ==========================================
  const handleViewDetails = (propertyId) => {
    Navigate(`/buyer/property-details/${propertyId}`);
  };

  const handleViewAllChats = () => {
    Navigate("/buyer/chats");
  };

  const handleViewWishlist = () => {
    Navigate("/buyer/wishlist");
  };

  const toggleWishlist = (propertyId) => {
    if (wishlist.includes(propertyId)) {
      setWishlist(wishlist.filter((id) => id !== propertyId));
    } else {
      setWishlist([...wishlist, propertyId]);
    }
  };

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <Container fluid>
      <BuyerMasterLayout pageTitle="Dashboard">

  {isLoading ? (

    <div className="buyerdashboard-loading">
      <div className="buyerdashboard-loader-spinner"></div>

      <p>Loading dashboard...</p>
    </div>

  ) : (

        <div className="buyerdashboard-container">
          {/* TOP STATS CARDS */}
          <div className="buyerdashboard-stats-cards-row">
            {statsCards.map((card) => (
              <div
                key={card.id}
                className="buyerdashboard-stat-card"
                style={{ borderTopColor: card.color }}
              >
                <div
                  className="buyerdashboard-stat-icon"
                  style={{
                    backgroundColor: `${card.color}20`,
                    color: card.color,
                  }}
                >
                  {card.icon}
                </div>
                <div className="buyerdashboard-stat-content">
                  <h3 className="buyerdashboard-stat-title">{card.title}</h3>
                  <div className="buyerdashboard-stat-value">{card.value}</div>
                  {card.badge && (
                    <span className="buyerdashboard-stat-badge">
                      {card.badge}
                    </span>
                  )}
                  {card.subText && (
                    <span className="buyerdashboard-stat-subtext">
                      {card.subText}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* MAIN CONTENT - 3 COLUMNS */}
          <div className="buyerdashboard-main-content-grid">
            {/* MIDDLE COLUMN */}
            <div className="buyerdashboard-middle-column">
              {/* NEXT VISIT REQUESTS */}
              <div className="buyerdashboard-section-card">
                <div className="buyerdashboard-section-header">
                  <h2 className="buyerdashboard-section-title">
                    Next Visit Requests
                  </h2>
                </div>

                <div className="buyerdashboard-visit-requests-list">
                  {visits.map((visit) => (
                    <div
                      key={visit.id}
                      className="buyerdashboard-visit-request-item"
                    >
                      <div className="buyerdashboard-visit-icon">
                        <FaCalendarAlt />
                      </div>
                      <div className="buyerdashboard-visit-details">
                        <h4 className="buyerdashboard-visit-property">
                          {visit.exproperty?.property_title}
                        </h4>
                        <p className="buyerdashboard-visit-date-secondary">
                          {visit.secondaryDate}
                        </p>
                      </div>
                      <div className="buyerdashboard-visit-time-section">
                        <span className="buyerdashboard-visit-date">
                          {visit.bookingDate}
                        </span>
                        <span className="buyerdashboard-visit-time">
                          {visit.bookingTime}
                        </span>
                        <span
                          className={`buyerdashboard-visit-status ${visit.status?.toLowerCase() || ""}`}
                        >
                          {visit.status}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <button className="buyerdashboard-view-all-btn">
                  View All <FaChevronRight />
                </button>
              </div>
            </div>

            {/* LEFT COLUMN */}
            <div className="buyerdashboard-left-column">
              {/* SAVED PROPERTIES */}
              <div className="buyerdashboard-section-card">
                <div className="buyerdashboard-section-header">
                  <h2 className="buyerdashboard-section-title">
                    Saved Properties
                  </h2>
                  <button className="buyerdashboard-view-details-link">
                    View Details
                  </button>
                </div>

                <div className="buyerdashboard-properties-list">
                  {properties?.map((property) => (
                    <div
                      key={property.id}
                      className="buyerdashboard-property-card"
                    >
                      <div className="buyerdashboard-property-image-wrapper">
                        <img
                          src={`${baseUrlForFiles}/${property.exproperty.expropertyimages[0].images|| ""}`}
                          alt={property?.property_title}
                          className="buyerdashboard-property-image"
                        />
                        {property.badge && (
                          <span className="buyerdashboard-property-badge">
                            {property.badge}
                          </span>
                        )}
                        <button
                          className={`buyerdashboard-wishlist-heart ${wishlist.includes(property.id) ? "active" : ""}`}
                          onClick={() => toggleWishlist(property.id)}
                        >
                          <FaHeart />
                        </button>
                      </div>

                      <div className="buyerdashboard-property-details">
                        <h3 className="buyerdashboard-property-name">
                          {property?.exproperty?.property_title}
                        </h3>
                        <p className="buyerdashboard-property-location">
                          {property?.exproperty?.location}
                        </p>
                        <div className="buyerdashboard-property-price">
                          {property?.exproperty?.price}
                        </div>

                        <div className="buyerdashboard-property-specs">
                          <span className="buyerdashboard-spec-item">
                            <FaBed /> {property?.exproperty?.bedrooms} Beds
                          </span>
                          <span className="buyerdashboard-spec-item">
                            <FaBath /> {property?.exproperty.bathrooms} Baths
                          </span>
                          <span className="buyerdashboard-spec-item">
                            <FaRuler /> {property?.exproperty?.size}
                          </span>
                        </div>

                        {/* <button 
                          className="buyerdashboard-view-details-btn"
                          onClick={() => handleViewDetails(property.id)}
                        >
                          View Details
                        </button> */}
                      </div>
                    </div>
                  ))}
                </div>

                {/* <button className="buyerdashboard-view-all-btn">
                  View All <FaChevronRight />
                </button> */}
              </div>

              {/* VISIT REQUESTS OVERVIEW */}
              {/* <div className="buyerdashboard-section-card">
                <div className="buyerdashboard-section-header">
                  <h2 className="buyerdashboard-section-title">Visit Requests Overview</h2>
                  <button className="buyerdashboard-view-all-link">View All <FaChevronRight /></button>
                </div>

                <div className="buyerdashboard-mini-properties-list">
                  {visitRequestsOverview.map((item) => (
                    <div key={item.id} className="buyerdashboard-mini-property-card">
                      <img src={item.image} alt={item.name} className="buyerdashboard-mini-property-image" />
                      <div className="buyerdashboard-mini-property-info">
                        <h4 className="buyerdashboard-mini-property-name">{item.name}</h4>
                        <div className="buyerdashboard-mini-property-specs">
                          <span>{item.beds} Beds</span>
                          <span>{item.baths} Baths</span>
                          <span>{item.rooms} D+</span>
                        </div>
                      </div>
                      <span className={`buyerdashboard-status-badge-mini ${item.status.toLowerCase()}`}>
                        {item.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div> */}
            </div>

            {/* RIGHT COLUMN */}
            <div className="buyerdashboard-right-column">
              {/* WISHLIST */}
              {/* <div className="buyerdashboard-section-card">
                <div className="buyerdashboard-section-header">
                  <h2 className="buyerdashboard-section-title">Wishlist</h2>
                  <button className="buyerdashboard-collapse-btn">^</button>
                </div>

                <div className="buyerdashboard-wishlist-items">
                  {wishlistProperties.map((property) => (
                    <div key={property.id} className="buyerdashboard-wishlist-item">
                      <img src={property.image} alt={property.name} className="buyerdashboard-wishlist-image" />
                      <div className="buyerdashboard-wishlist-info">
                        <h4 className="buyerdashboard-wishlist-name">{property.name}</h4>
                        <div className="buyerdashboard-wishlist-price">{property.price}</div>
                        <div className="buyerdashboard-wishlist-specs">
                          <span>{property.beds}b</span>
                          <span>{property.baths}B</span>
                          <span>{property.sqft}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <button className="buyerdashboard-view-wishlist-btn" onClick={handleViewWishlist}>
                  View All Wishlist
                </button>
              </div> */}

              {/* CHAT WITH SELLER */}
              <div className="buyerdashboard-section-card">
                <div className="buyerdashboard-section-header">
                  <h2 className="buyerdashboard-section-title">
                    Chat with Seller
                  </h2>
                  <button
                    className="buyerdashboard-view-all-link"
                    onClick={handleViewAllChats}
                  >
                    View All
                  </button>
                </div>

                <div className="buyerdashboard-chat-list">
                  {chats.map((chat) => (
                    <div key={chat.id} className="buyerdashboard-chat-item">
                      <img
                        src={`${baseUrlForFiles}${chat.exseller?.profileImage}`} 
                        alt={chat.exseller?.firstName}
                        className="buyerdashboard-chat-avatar"
                      />
                      <div className="buyerdashboard-chat-content">
                        <div className="buyerdashboard-chat-header-row">
                          <h4 className="buyerdashboard-chat-agent">
                            {chat.exseller?.firstName} {chat.exseller?.lastName}
                          </h4>
                          <span className="buyerdashboard-chat-time">
                            {new Date(chat.latest_chat?.created_at).toLocaleDateString()}
                          </span>
                        </div>
                        <p className="buyerdashboard-chat-message">
                          {chat.latest_chat?.massage}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="buyerdashboard-view-all-chats-btn"
                  onClick={handleViewAllChats}
                >
                  View All Chats <FaChevronRight />
                </button>
              </div>

              {/* AI RECOMMENDATION */}
              <div className="buyerdashboard-section-card buyerdashboard-ai-recommendation-card">
                <div className="buyerdashboard-section-header">
                  <h2 className="buyerdashboard-section-title">
                    AI Recommendation
                  </h2>
                  <button className="buyerdashboard-collapse-btn">^</button>
                </div>

                <div className="buyerdashboard-ai-recommendation-content">
                  <div className="buyerdashboard-ai-input-row">
                    <div className="buyerdashboard-ai-input-item">
                      <span className="buyerdashboard-ai-label">
                        Plot Size:
                      </span>
                      <span className="buyerdashboard-ai-value">
                        {aiRecommendation.plotSize}
                      </span>
                    </div>
                    <div className="buyerdashboard-ai-input-item">
                      <span className="buyerdashboard-ai-label">
                        Family Members:
                      </span>
                      <span className="buyerdashboard-ai-value">
                        {aiRecommendation.familyMembers}
                      </span>
                    </div>
                  </div>

                  <div className="buyerdashboard-ai-input-item buyerdashboard-full-width">
                    <span className="buyerdashboard-ai-label">
                      House Preference:
                    </span>
                    <span className="buyerdashboard-ai-value">
                      {aiRecommendation.housePreference}
                    </span>
                  </div>

                  <div className="buyerdashboard-ai-output-section">
                    <h4 className="buyerdashboard-ai-output-title">Output</h4>
                    <div className="buyerdashboard-ai-output-items">
                      {aiRecommendation.output.map((item, index) => (
                        <div
                          key={index}
                          className="buyerdashboard-ai-output-item"
                        >
                          <span className="buyerdashboard-ai-output-icon">
                            {item.icon}
                          </span>
                          <span className="buyerdashboard-ai-output-text">
                            {item.text}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          )}
      </BuyerMasterLayout>
    </Container>
  );
};
  
export default BuyerDashboard;
